/** @format */

import React from 'react';
import '../css/Slice.css';
import { useDispatch } from 'react-redux';
import { openVideo } from '../features/video';

import graduate from '../images/graduate-cap 1.png';
import play from '../images/play 2.png';
import read from '../images/read 1.png';

import suitcase from '../images/suitcase.svg';
import ribbon from '../images/ribbon.svg';

import { IoStar } from 'react-icons/io5';

import image1 from '../images/1.jpg';
import image2 from '../images/2.jpg';
import image3 from '../images/3.jpg';

import avatar from '../images/avatar.jpg';

const Slice = () => {
  const dispatch = useDispatch();

  const handleLink = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute('href');
    const location = document.querySelector(target).offsetTop;
    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  return (
    <section className='Slice'>
      <div className='slice-container container padding'>
        <div className='slice-content'>
          <div className='slice-content-text'>
            <h2 className='slice-content-heading'>
              Aprende nuevas habilidades con la mejor{' '}
              <span className='heading-highlight'>Academia 3D</span>
            </h2>
            <p className='slice-content-paragraph'>
              Mejora tu perfil profesional, aprendiendo nuevas
              habilidades para las industrias creativas con docentes
              especialistas.
            </p>
          </div>
          <div className='slice-content-buttons'>
            <button
              className='slice-btn slice-btn-colored'
              onClick={() => {
                dispatch(
                  openVideo({
                    modal: true,
                    url: 'https://www.youtube.com/watch?v=VXvaSAsrJw8',
                    type: 'common',
                  })
                );
              }}>
              Ver trailer
            </button>
            <button
              href='#entrenamientos'
              onClick={handleLink}
              className='slice-btn slice-btn-outline'>
              Únete Ahora
            </button>
          </div>
          <div className='slice-content-icons'>
            <div className='slice-content-icons-item'>
              <img src={graduate} alt='item' />
              <span>Sorprendentes resultados en corto tiempo</span>
            </div>
            <div className='slice-content-icons-item'>
              <img src={play} alt='item' />
              <span>Clases online en vivo</span>
            </div>
            <div className='slice-content-icons-item'>
              <img src={read} alt='item' />
              <span>Inicia tu curva de aprendizaje</span>
            </div>
          </div>
        </div>
        <div className='slice-images'>
          <div className='slice-images-column'>
            <div className='slice-images-group-1'>
              <div className='slice-images-img'>
                <img
                  src={image1}
                  alt='item'
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div className='slice-images-tag-1'>
                <div className='slice-images-tag-1-circle'>
                  <img src={suitcase} alt='item' />
                </div>
                <div className='slice-images-tag-info'>
                  <span className='slice-images-tag-1-info-text-1'>
                    Formamos
                  </span>
                  <span className='slice-images-tag-1-info-text-2'>
                    Especialistas
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='slice-images-column'>
            <div className='slice-images-group-3'>
              <div className='slice-images-img'>
                <img
                  src={image2}
                  alt='item'
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div className='slice-images-tag-3'>
                <div
                  className='slice-images-tag-3-circle'
                  style={{ overflow: 'hidden' }}>
                  <img
                    src={avatar}
                    alt='item'
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div>
                <div className='slice-images-tag-info'>
                  <span className='slice-images-tag-3-info-text-1'>
                    Carlos Acevedo
                  </span>
                  <span className='slice-images-tag-3-info-text-2'>
                    Alumno Destacado
                  </span>
                  <span className='slice-images-tag-3-info-stars'>
                    <IoStar />
                    <IoStar />
                    <IoStar />
                    <IoStar />
                    <IoStar />
                  </span>
                </div>
              </div>
            </div>
            <div className='slice-images-group-2'>
              <div className='slice-images-img'>
                <img
                  src={image3}
                  alt='item'
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
              <div className='slice-images-tag-2'>
                <div className='slice-images-tag-info'>
                  <span className='slice-images-tag-2-info-text-1'>
                    ¡Felicidades!
                  </span>
                  <span className='slice-images-tag-2-info-text-2'>
                    Ganador de Beca del 100%
                  </span>
                </div>
                <div className='slice-images-tag-2-circle'>
                  <img src={ribbon} alt='item' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slice;
